export default {
  'ssoError.title1': 'Your request cannot be completed by the bill payment service.',
  'ssoError.title2': 'Please contact your administrator or financial institution for assistance.'
};
